import { render } from "./manage-script.vue?vue&type=template&id=48e86648&scoped=true"
import script from "./manage-script.vue?vue&type=script&lang=js"
export * from "./manage-script.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./manage-script.vue?vue&type=style&index=1&id=48e86648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e86648"]])

export default __exports__